import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export const AuthCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthCallback = async () => {
            const { error } = await supabase.auth.getSession();
            if (error) {
                console.error('Error en el callback de autenticación:', error.message);
                navigate('/login?error=auth-callback-failed');
            } else {
                // Autenticación exitosa, redirigir al juego o selección de libro
                navigate('/select-book');
            }
        };

        handleAuthCallback();
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <h2 className="text-xl font-bold">Procesando inicio de sesión...</h2>
                <p className="text-muted-foreground mt-2">Por favor, espera un momento.</p>
            </div>
        </div>
    );
};
